import React from 'react';

import { Container } from '@mui/material';


export default function Header() {
    return (
        <div className="header">
            <Container maxWidth="xl">
                <h1>良心月餅2022</h1>
            </Container>
        </div>
    )
};
